module.exports = __webpack_public_path__ + "img/wxpayphone.52ecad42.png";